import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import NP from "../../../1. Core/NP";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import {IBattleEvent} from "../../Util";
import Delegate from "../../../1. Core/Delegate";
import Select from "../../../1. Core/Controls/Select/Select";



export default class EditEventDialog extends Dialog {

    private _Event: IBattleEvent;
    private EvSaved: Delegate;
    private _dlgControls: Select[];


    _initFields(settings: object) {
        this._Event = null;
        this.EvSaved = new Delegate();
        super._initFields(settings);
        this._Caption = NP.RM.getString('EditEvent');
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
        this._AutoDestroy = true;
    }

    _render() {
        super._render();


        let attItems = [
            {Content: 'J', Value: 'J'},
            {Content: 'C', Value: 'C'},
            {Content: 'HL', Value: 'HL'},
            {Content: 'HR', Value: 'HR'},
            {Content: 'UL', Value: 'UL'},
            {Content: 'UR', Value: 'UR'},
        ]

        let defItems = [
            {Content: 'Away', Value: 'U'},
            {Content: 'Block', Value: 'Block'},
            {Content: 'CB', Value: 'CB'},
            {Content: 'CL', Value: 'CL'},
            {Content: 'CriticalPunch', Value: 'CriticalPunch'},
            {Content: 'Dive down', Value: 'N'},
            {Content: 'Footwork', Value: 'W'},
            {Content: 'Knockdown', Value: 'Knockdown'},
            {Content: 'LB', Value: 'LB'},
            {Content: 'RB', Value: 'RB'},
            {Content: 'P1', Value: 'P1'},
            {Content: 'P2', Value: 'P2'},
            {Content: 'P3', Value: 'P3'},
            {Content: 'P4', Value: 'P4'},
            {Content: 'P5', Value: 'P5'},
            {Content: 'P6', Value: 'P6'},
            {Content: 'P7', Value: 'P7'},
        ]

		this._dlgControls = [
            new Select({
                FloatingLabel: 'Action',
                Items: attItems,
				Value: this._Event.Action
            }),
			new Select({
				FloatingLabel: 'Answer',
				Items: defItems,
				Value: this._Event.Answer
			})
        ];


        this.setContent(this._dlgControls)
    }


    async _onOkButtonClick() {
        let editedEvent = {
			...this._Event
		};


        editedEvent.Action = this._dlgControls[0].getValue()
		editedEvent.Answer = this._dlgControls[1].getValue()
        await this.updateEvent(editedEvent as IBattleEvent);

        this.EvSaved.fire(this);
        this.hide();
    }

    async updateEvent(ev: IBattleEvent) {

        await ServerAPI.post("/box/event", ev);

        for (let key in ev) {
            this._Event[key] = ev[key]
        }
    }
}
